export enum TranslatedChangeTypeFields {
  OperatorAdded = 'Operator Added',
  OperatorEdited = 'Operator Edited',
  ThrdPartyLiveSupportAdded = 'Third Party: Live Support Added',
  ThrdPartyLiveSupportEdited = 'Third Party: Live Support Edited',
  PlayerAuthSecuritySettingsEdited = 'Player Authentication: Security Settings Edited',
}
